import { Injectable, Signal, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnterpriseService {

  private document = signal<string | null>(null);
  private customerId = signal<string | null>(null);
  private economicGroup = signal<string | null>(null);
  private enterpriseList = signal<any[]>([]);
  private schemesList = signal<any[]>([]);
  private enterprise = signal<any>(undefined);

  setDocument(v: string) {
    sessionStorage.setItem('document', v);
    this.document.set(v);
  }

  getDocument(): Signal<string | null> {
    if (!this.document()) {
      const document = sessionStorage.getItem('document');
      this.document.set(document);
    }
    return this.document.asReadonly();
  }

  setCustomerId(v: string) {
    sessionStorage.setItem('enterpriseSelectedCustomerId', v);
    this.customerId.set(v);
  }

  getCustomerId(): Signal<string | null> {
    return this.customerId.asReadonly();
  }

  setEconomicGroup(v: string) {
    this.economicGroup.set(v);
  }

  getEconomicGroup(): Signal<string | null> {
    return this.economicGroup.asReadonly();
  }

  setEnterpriseList(v: any[]) {
    this.enterpriseList.set(v);
  }

  getEnterpriseList(): Signal<any[]> {
    return this.enterpriseList.asReadonly();
  }

  setSchemesList(v: any[]) {
    this.schemesList.set(v);
  }

  getSchemesList(): Signal<any[]> {
    return this.schemesList.asReadonly();
  }

  setEnterprise(v: any) {
    this.enterprise.set(v);
  }

  getEnterprise(): Signal<any> {
    return this.enterprise.asReadonly();
  }
}
